<template>
    <div>
        <MainPage @clickBack="clickBack()" customClass="pb-0 max-w-6xl min-h-screen lg:relative">
            <div v-if="isLoaded" class="lg:pt-10 lg:pb-4">

                <div class="lg:grid lg:grid-cols-3 lg:border lg:border-a-brown-d7c7b8 ">
                    <div class="map map-area lg:order-last lg:col-span-2" id="map"></div>
                    <div class="px-4 branch-list">
                        <div class="text-14 text-a-brown-502314 pt-4 pb-2">{{lbl.deliverymethod.nearby}}</div>
                        <BranchItem
                            v-for="(branch, k) in filteredBranchList"
                            :branch="branch"
                            :key="k"
                            @selectBranch="selectBranch($event)"
                        ></BranchItem>
                    </div>
                </div>
                <div class="absolute w-full px-4 lg:px-0 wrapper-search max-w-6xl" :class="[cookieClass]">
                    <div class="flex shadow-text bg-white p-2 rounded-5">
                        <img class="mr-2" src="@/assets/icon/icon-search-gray.svg"/>
                        <input class="w-full placeholder-a-brown-9f8273 text-a-brown-502314 text-14 lg:text-16"
                            id="search-input"
                            v-model="search"
                            type="text"
                            placeholder="Search your location">
                    </div>
                </div>
                <div class="control-map">
                    <img class="btn-current-map" src="../../../assets/map/current-location.svg" @click="clickCurrentLocation()">
                </div>
            </div>
        </MainPage>
    </div>
</template>

<script>
//lib
import { Loader } from '@googlemaps/js-api-loader'; //https://www.npmjs.com/package/@googlemaps/js-api-loader
//components
import MainPage from "@/components/Layout/Page/MainPage.vue";
import BranchItem from "../component/BranchItem.vue";
//helper
import Location from "@/helper/LocationHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
//service
import { BranchConfigBuilder } from '../model/BranchConfigModel.js';
import BKDeliveryMethod from '../service/BKDeliveryMethod.js';
//model
import { locationModel } from '../model/LocationModel.js'
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
import CookieMixin from '@/mixin/CookieMixin.js';
// svg icon
import iconPinMap from "@/assets/icon/ic-pin-bk.svg"
import iconPinCurrent from "@/assets/icon/ic-pin-current-bk.svg";
export default {
    name: "SelectBranch",
    inject: ['DeliveryStore'],
    mixins: [ModalMixin,LocaleMixin,CookieMixin],
    components: {
        MainPage,
        BranchItem
    },
    data: function() {
        return {
            currentLocation: {
                lat: 13.7451765,
                lng: 100.5081332
            },
            isLoaded: false,
            branchList: [],

            search: "",
            map: null,
            googleMaps: null,
            geocoder: null,
            markers: []
        };
    },
    computed: {
        filteredBranchList() {
            return this.branchList.filter(branch => {
                if (this.localeCode == 1033) {
                    return branch.nameEN.toLowerCase().includes(this.search.toLowerCase());
                } else {
                    return branch.name.toLowerCase().includes(this.search.toLowerCase());
                }
            })
        }
    },
    created: async function() {
        await this.initialBranch();
        await this.getCurrentLocation();
    },
    mounted: function() {
        this.modal.loadingModal.show();
    },
    methods: {
        getCurrentLocation: function() {
            return new Promise((resolve) => {
                Location.getCurrentLocation().then((location) => {
                    this.currentLocation = location;
                    this.initialBranch();
                    resolve();
                }).catch((err) => {
                    console.log(err);
                    resolve();
                });
            });
        },
        initialBranch: async function () {
            this.branchConfig = new BranchConfigBuilder()
                .setCenter(this.currentLocation.lat,this.currentLocation.lng)
                .setIsPickupBranchOpen(true)
                .create();

            if (await this.apiGetBranch()) {
                this.isLoaded = true;
                await this.initialMaps();
                this.pinBranch();
                this.pinCurrent();
            }
        },
        initialMaps: function () {
            return new Promise((resolve) => {
                var key = ConfigManager.getGoogleMapsKey()
                const loader = new Loader({
                    apiKey: key,
                    version: "weekly",
                    libraries: ["places"]
                });
                loader.load().then((google) => {
                    //this.geocoder = new google.maps.Geocoder();
                    // this.searchBox = new google.maps.places.SearchBox(document.getElementById("search-input"));
                    this.map = new google.maps.Map(document.getElementById("map"), {
                        center: {
                            lat: this.branchList[0].location.latitude,
                            lng: this.branchList[0].location.longitude,
                        },
                        zoom: 15,
                        mapTypeId: "roadmap",
                        disableDefaultUI: true,
                        fullscreenControl: false,
                        clickableIcons: false,
                        clickableLabels: false,
                        zoomControl: true,
                    });
                    this.map.addListener('click', (e) => {
                        this.map.setCenter(e.latLng);
                        //this.pinChange(e.latLng);
                    });
                    this.map.addListener('bounds_changed', () => {
                        //this.addressText = "";
                    });
                    // this.searchBox.addListener('places_changed', () => {
                    //     let places = this.searchBox.getPlaces();
                    //     if (places.length == 0) return;

                    //     this.pinChange(places[0].geometry.location);
                    // });

                    this.googleMaps = google;

                    resolve(true);
                })
                .catch(e => {
                    console.log(e);
                    // do something
                });
            });
        },
        pinBranch: function() {
            for (let branchItem of this.branchList) {
                if (branchItem.location) {
                    this.pinMarker(branchItem.location.latitude,branchItem.location.longitude)
                }
            }
        },
        pinMarker: function(lat, lng) {
            let positionBranch = {
                lat: lat,
                lng: lng,
            }
            this.markers = [];
            this.markers.push(
                new this.googleMaps.maps.Marker({
                    position: positionBranch,
                    icon: iconPinMap,
                    map: this.map,
                    animation: this.googleMaps.maps.Animation.DROP,
                })
            );
        },
        pinCurrent: function() {
            console.log("pinCurrent");
            this.markers = [];
            this.markers.push(
                new this.googleMaps.maps.Marker({
                    position: this.currentLocation,
                    icon: iconPinCurrent,
                    map: this.map,
                    animation: this.googleMaps.maps.Animation.DROP,
                })
            );
        },
        clickCurrentLocation: function () {
            this.map.setCenter(this.currentLocation);
        },
        selectBranch: function(objBranch) {
            if (this.DeliveryStore.state.delivery.location) {
                this.DeliveryStore.state.delivery.location.setValueFormBranchModel(objBranch);
            } else {
                let loc = new locationModel();
                loc.setValueFormBranchModel(objBranch);
                this.DeliveryStore.state.delivery.location = loc;
            }

            this.$router.back();
        },
        apiGetBranch: async function() {
            return new Promise((resolve) => {
                let params = this.branchConfig.getParams()
                BKDeliveryMethod.apiGetBranch(params).subscribe({
                    next: (data) => {
                        console.log(data);
                        this.branchList = data;
                        this.modal.loadingModal.hide();
                        resolve(true);
                    },
                    error: (err) => {
                        this.modal.loadingModal.hide();
                        resolve(false);
                        this.errorApi(err);
                    },
                });
            });
        },
        clickBack: function() {
            this.$router.back();
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    .map-area {
        height: calc(100vh / 2);

        @include min-desktop {
            height: calc(100vh - 240px);
        }

    }
    .branch-list {
        @include min-desktop {
            height: calc(100vh - 240px);
            overflow-y: scroll;
        }
    }
    .wrapper-search {
        top: 72px;
        @include min-desktop {
            top: 140px;
        }

        &.accept-cookie {
            top: 160px;
            @include min-desktop {
                top: 190px;
            }
        }
    }
    .control-map {
        position: absolute;
        right: 12px;
        bottom: calc(50% + 55px);
        @include min-desktop {
            bottom: 155px;
        }
        .btn-current-map {
            width: 34px;
            right: 12px;
        }
    }
</style>
